import React from 'react';
import propTypes from 'prop-types';
import moment from 'moment';

// components
import { DatePicker } from '@tcc/crate';

const baseString = 'vra-harvest-date';

const HarvestDate = ({
  date,
  onSelectDate
}) => {
  return (
    <DatePicker
      className={baseString}
      maxDate={moment().add(1,'years').toISOString()}
      minDate={moment().subtract(1,'years').toISOString()}
      moment={moment}
      onChangeDate={onSelectDate}
      selected={date}
      testId='date-picker'
    />
  );
};


HarvestDate.propTypes ={
  date: propTypes.string.isRequired,
  onSelectDate: propTypes.func.isRequired
};

export default HarvestDate;
